/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserModerationsModeratorControllerFindManyQueryResponse,
  UserModerationsModeratorControllerFindManyQueryParams,
  UserModerationsModeratorControllerFindMany401,
} from '../types/UserModerationsModeratorControllerFindMany.ts';

function getUserModerationsModeratorFindManyUrl() {
  const res = { method: 'GET', url: `/api/moderator/user-moderations` as const };
  return res;
}

/**
 * {@link /api/moderator/user-moderations}
 */
export async function userModerationsModeratorFindMany(
  params?: UserModerationsModeratorControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    UserModerationsModeratorControllerFindManyQueryResponse,
    ResponseErrorConfig<UserModerationsModeratorControllerFindMany401>,
    unknown
  >({ method: 'GET', url: getUserModerationsModeratorFindManyUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
